import React from 'react';
import '../../styles/testimonials/testimonials.scss';

const TestimonialCard = (props) => {
    const getInitials = (name) => {
        return name
            .split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase();
    };
    
    return(
        <div id={props.id} className='testimonial-card-layout'> 
            {props.photo ? (
                <img id='testimonial-pic' alt={props.name} src={props.photo}></img>
            ) : (
                <div id='testimonial-pic' style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '2rem',
                    fontWeight: 'bold',
                    color: '#333',
                    backgroundColor: '#e0e0e0'
                }}>
                    {getInitials(props.name)}
                </div>
            )}
            <section id='card'>
                <p id='testimonial-text'>
                    {props.text}
                </p>
                <hr id='line'></hr>
                <section id='test-bottom'>
                    <p id='name'>{props.name}</p>
                    <p id='house'>{props.house}</p>
                </section>
                
            </section>
        </div>
    );
}


export default TestimonialCard;